var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":"配置编辑"}},[_c('Form',{ref:"configForm",attrs:{"model":_vm.configForm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }